import React, { useEffect, useRef } from 'react';
import DatePicker from 'react-datepicker';
import { FormApi } from 'final-form';
import { Field } from 'react-final-form';
import CustomDatePicker from '../../components/filter/CustomDatePicker';
import styles from './ReportList.module.scss';

export interface IDateRangeFormSlice {
  fromDate?: Date | string | null;
  toDate?: Date | string | null;
}

interface IDateRangeFieldsProps {
  form: FormApi<any>;
  formValues: IDateRangeFormSlice;
  fromDateFieldName: string;
  toDateFieldName: string;
}

const DateRangeFields = ({
  form,
  formValues,
  fromDateFieldName,
  toDateFieldName
}: IDateRangeFieldsProps): React.ReactElement => {
  const fromDatePickerRef = useRef<DatePicker>(null);
  const toDatePickerRef = useRef<DatePicker>(null);
  const fromDate = formValues.fromDate;
  const toDate = formValues.toDate;

  useEffect(() => {
    if (fromDate && toDate) {
      return;
    }

    const currentDate = new Date();
    const firstDateOfCurrentMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    if (!fromDate) {
      form.change(fromDateFieldName, firstDateOfCurrentMonth);
    }

    if (!toDate) {
      form.change(toDateFieldName, currentDate);
    }
  }, [form, fromDateFieldName, toDateFieldName, fromDate, toDate]);

  useEffect(() => {
    if (fromDate && toDate && new Date(toDate) < new Date(fromDate)) {
      form.change(toDateFieldName, fromDate);
    }
  }, [form, toDateFieldName, fromDate, toDate]);

  return (
    <>
      <Field
        name={fromDateFieldName}
        render={({ input }) => (
          <div className='py-dot625'>
            <p className='mb-dot25'>Start Date</p>
            <div>
              <CustomDatePicker
                pickerRef={fromDatePickerRef}
                dayReducer={0}
                selectedDate={input.value || null}
                onDateSelect={(date: Date) => input.onChange(date)}
              />
            </div>
          </div>
        )}
      />
      <Field
        name={toDateFieldName}
        render={({ input }) => (
          <div className={fromDate ? 'py-dot625' : `${styles.disable} py-dot625`}>
            <p className='mb-dot25'>End Date</p>
            <div>
              <CustomDatePicker
                pickerRef={toDatePickerRef}
                dayReducer={0}
                selectedDate={input.value || null}
                minDate={fromDate ? new Date(fromDate) : undefined}
                onDateSelect={(date: Date) => input.onChange(date)}
              />
            </div>
          </div>
        )}
      />
    </>
  );
};

export default DateRangeFields;
